<template>
  <div class="rank_item">
    <div class="rank_main_content">
      <template v-if="props_data.rank < 3">
        <div class="rank_ranking" :class="'ranking' + (props_data.rank + 1)"></div>
      </template>
      <template v-else>
        <div class="rank_ranking">{{ props_data.rank + 1 }}</div>
      </template>
      <div class="rank_short_desc">
        <div class="rank_short_name">
          {{ props_data.short_name }}
        </div>
        <div class="rank_score">{{ is_zh ? props_data.total_score : props_data.score }}分</div>
      </div>
      <div class="rank_img" :class="props_data.new_tag == 1 ? 'rank_new' : ''">
        <img :src="props_data.model_img" />
        <div class="no_promission" v-if="props_data.has_permission == 0">
          <div class="no_promission_icon"></div>
          <div class="no_promission_text">暂无权限查看</div>
        </div>
      </div>
      <div class="rank_desc">
        <div class="rank_desc_line">
          <div class="rank_desc_item">
            <div class="rank_attr">车型：</div>
            <div class="rank_val">{{ props_data.model_name }}</div>
          </div>
          <div class="rank_desc_item">
            <div class="rank_attr">评测体系版本：</div>
            <div class="rank_val">{{ props_data.review_model_id == 1 ? '5.0' : '4.0' }}</div>
          </div>
        </div>
        <div class="rank_desc_line">
          <div class="rank_desc_item">
            <div class="rank_attr">能源：</div>
            <div class="rank_val">
              {{ getEnergyType(props_data.energy_type) }}
            </div>
          </div>
          <div class="rank_desc_item">
            <div class="rank_attr">指导价：</div>
            <div class="rank_val">{{ props_data.price }}万元</div>
          </div>
        </div>
      </div>
      <div class="rank_btns">
        <template v-if="props_data.has_permission == 0">
          <div class="rank_btn">
            <div class="rank_btn_icon icon_zs_gray"></div>
            <div class="rank_btn_text">车辆综述</div>
          </div>
          <div class="rank_btn" v-if="ceping_src">
            <div class="rank_btn_icon icon_cp_gray"></div>
            <div class="rank_btn_text">评测详情</div>
          </div>
          <div class="rank_btn">
            <div class="rank_btn_icon icon_db_gray"></div>
            <div class="rank_btn_text">对比</div>
          </div>
          <div class="rank_btn">
            <div class="rank_btn_icon icon_sc_gray"></div>
            <div class="rank_btn_text">收藏</div>
          </div>
          <div class="rank_btn">
            <div class="rank_btn_icon icon_xzbg_gray"></div>
            <div class="rank_btn_text">下载报告</div>
          </div>
          <div class="rank_btn">
            <div class="rank_btn_icon icon_gn_gray"></div>
            <div class="rank_btn_text">功能</div>
          </div>
        </template>
        <template v-else-if="props_data.has_permission == 1">
          <router-link class="rank_btn" :to="{
            path: route_type + '/v2/report/index',
            query: {
              model_img: props_data.model_img,
              model_name: props_data.short_name || props_data.model_name,
              model_id: props_data.model_id,
              report_id: props_data.report_id,
            },
          }">
            <div class="rank_btn_icon icon_zs"></div>
            <div class="rank_btn_text">车辆综述</div>
          </router-link>
          <router-link v-if="ceping_src" class="rank_btn" :to="ceping_src">
            <div class="rank_btn_icon icon_cp"></div>
            <div class="rank_btn_text">评测详情</div>
          </router-link>
          <div class="rank_btn" @click="
            checkChange(
              props_data,
              contrastListIds.indexOf(props_data.model_id * 1) == -1
            )
            ">
            <div class="rank_btn_icon" :class="contrastListIds.indexOf(props_data.model_id * 1) == -1
              ? 'icon_db'
              : 'icon_db_act'
              "></div>
            <div class="rank_btn_text">对比</div>
          </div>
          <div class="rank_btn" @click.stop="
            ChangeCollect(props_data.is_collect == 1 ? 'del' : 'add', props_data)
            ">
            <div class="rank_btn_icon" :class="props_data.is_collect == 1 ? 'icon_sc_act' : 'icon_sc'"></div>
            <div class="rank_btn_text">收藏</div>
          </div>
          <div class="rank_btn rank_btn_xzbg" @click="handleDownloadReport(props_data)">
            <div class="rank_btn_icon" :class="props_data.download_permission ? 'icon_xzbg' : 'icon_xzbg_gray'"></div>
            <div class="rank_btn_text">下载报告</div>
            <div class="rank_download">
              <a v-if="props_data.download_permission" class="rank_download_item"
                :href="apiUrl + 'v2/report/download?model_id=' + props_data.model_id">
                {{ props_data.short_name || props_data.model_name }}测评数据
              </a>
              <div v-else class="rank_download_item" @click="noPermission">
                {{ props_data.short_name || props_data.model_name }}测评数据
              </div>
              <div v-if="showExpertReport" class="rank_download_item" @click="downloadSummary">
                单车专家测评报告
              </div>
              <div v-if="showUserReport" class="rank_download_item" @click="downloadComparison">
                单车用户测评报告
              </div>
            </div>
          </div>

          <div class="rank_btn rank_btn_gn">
            <div class="rank_btn_icon icon_gn"></div>
            <div class="rank_btn_text">功能</div>
            <div class="rank_function">
              <div class="rank_function_item" @click.self="openCarAttrDrawer(props_data.model_id)">
                车型参数
              </div>
              <div class="rank_function_item" @click.self="toPage('/v2/summary/first', props_data)">
                标杆分析
              </div>
              <router-link class="rank_function_item" :to="{
                path: route_type + '/v2/funcVideo',
                query: {
                  model_img: props_data.model_img,
                  model_name: props_data.short_name || props_data.model_name,
                  model_id: props_data.model_id,
                  report_id: props_data.report_id,
                },
              }">
                核心场景分析
              </router-link>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- 历史数据按钮 -->
    <div v-if="hasOldData" class="rank_history_btn" @click="toggleHistoryData">
      <div class="rank_history_icon" :class="{ 'expanded': showHistoryData }"></div>
      <div class="rank_history_text">{{ showHistoryData ? '收起历史版本' : '展开历史版本' }}</div>
    </div>

    <!-- 历史数据展示 - 独立一行 -->
    <div v-if="hasOldData && showHistoryData" class="rank_old_desc">
      <div v-for="(oldItem, index) in props_oldData" :key="index" class="rank_main_content">
        <div class="rank_short_desc">
          <div class="rank_short_name">
            {{ oldItem.short_name || oldItem.model_name }}
          </div>
          <div class="rank_score">{{ is_zh ? oldItem.total_score : oldItem.score }}分</div>
        </div>

        <div class="rank_btns">
          <template v-if="oldItem.has_permission == 0">
            <div class="rank_btn">
              <div class="rank_btn_icon icon_zs_gray"></div>
              <div class="rank_btn_text">车辆综述</div>
            </div>
            <div class="rank_btn" v-if="ceping_src">
              <div class="rank_btn_icon icon_cp_gray"></div>
              <div class="rank_btn_text">评测详情</div>
            </div>
            <div class="rank_btn">
              <div class="rank_btn_icon icon_db_gray"></div>
              <div class="rank_btn_text">对比</div>
            </div>
            <div class="rank_btn">
              <div class="rank_btn_icon icon_sc_gray"></div>
              <div class="rank_btn_text">收藏</div>
            </div>
            <div class="rank_btn">
              <div class="rank_btn_icon icon_xzbg_gray"></div>
              <div class="rank_btn_text">下载报告</div>
            </div>
            <div class="rank_btn">
              <div class="rank_btn_icon icon_gn_gray"></div>
              <div class="rank_btn_text">功能</div>
            </div>
          </template>
          <template v-else-if="oldItem.has_permission == 1">
            <router-link class="rank_btn" :to="{
              path: route_type + '/v2/report/index',
              query: {
                model_img: oldItem.model_img,
                model_name: oldItem.short_name || oldItem.model_name,
                model_id: oldItem.model_id,
                report_id: oldItem.report_id,
              },
            }">
              <div class="rank_btn_icon icon_zs"></div>
              <div class="rank_btn_text">车辆综述</div>
            </router-link>
            <router-link v-if="ceping_src" class="rank_btn" :to="ceping_src">
              <div class="rank_btn_icon icon_cp"></div>
              <div class="rank_btn_text">评测详情</div>
            </router-link>
            <div class="rank_btn" @click="
              checkChange(
                oldItem,
                contrastListIds.indexOf(oldItem.model_id * 1) == -1
              )
              ">
              <div class="rank_btn_icon" :class="contrastListIds.indexOf(oldItem.model_id * 1) == -1
                ? 'icon_db'
                : 'icon_db_act'
                "></div>
              <div class="rank_btn_text">对比</div>
            </div>
            <div class="rank_btn" @click.stop="
              ChangeCollect(oldItem.is_collect == 1 ? 'del' : 'add', oldItem)
              ">
              <div class="rank_btn_icon" :class="oldItem.is_collect == 1 ? 'icon_sc_act' : 'icon_sc'"></div>
              <div class="rank_btn_text">收藏</div>
            </div>
            <div class="rank_btn rank_btn_xzbg" @click="handleDownloadReport(oldItem)">
              <div class="rank_btn_icon" :class="oldItem.download_permission ? 'icon_xzbg' : 'icon_xzbg_gray'"></div>
              <div class="rank_btn_text">下载报告</div>
              <div class="rank_download">
                <a v-if="oldItem.download_permission" class="rank_download_item"
                  :href="apiUrl + 'v2/report/download?model_id=' + oldItem.model_id">
                  {{ props_data.short_name || props_data.model_name }}测评数据
                </a>
                <div v-else class="rank_download_item" @click="noPermission">
                  {{ props_data.short_name || props_data.model_name }}测评数据
                </div>
                <div v-if="showExpertReport" class="rank_download_item" @click="downloadSummary">
                  单车专家测评报告
                </div>
                <div v-if="showUserReport" class="rank_download_item" @click="downloadComparison">
                  单车用户测评报告
                </div>
              </div>
            </div>
            <div class="rank_btn rank_btn_gn">
              <div class="rank_btn_icon icon_gn"></div>
              <div class="rank_btn_text">功能</div>
              <div class="rank_function">
                <div class="rank_function_item" @click.self="openCarAttrDrawer(oldItem.model_id)">
                  车型参数
                </div>
                <div class="rank_function_item" @click.self="toPage('/v2/summary/first', oldItem)">
                  标杆分析
                </div>
                <router-link class="rank_function_item" :to="{
                  path: route_type + '/v2/funcVideo',
                  query: {
                    model_img: oldItem.model_img,
                    model_name: oldItem.short_name || oldItem.model_name,
                    model_id: oldItem.model_id,
                    report_id: oldItem.report_id,
                  },
                }">
                  核心场景分析
                </router-link>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { getEnergyType } from "@/components/common/js/common.js";
import { addCollectV2, delCollectV2 } from "@/api";
import store from "@/store";
export default {
  name: "CarItem",
  components: {},
  props: {
    index: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
      deep: true,
    },
    oldData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    activeTab: {
      default: 0,
    },
    activeId: {
      default: 0,
    },
    activeName: {
      default: "",
    },
    my_model_info: {
      default: {},
    },
    ym_from: {
      default: "",
    },
    route_type: {
      default: "",
    },
  },
  // props
  setup(props, { emit }) {
    const apiUrl = process.env.VUE_APP_ADMIN_API;
    // const data = toRef(props, data)
    const props_data = ref(props.data);
    const props_oldData = ref(props.oldData && typeof props.oldData === 'object' ? props.oldData : {});
    const route = useRoute(),
      router = useRouter();

    const hideCompareBtnRef = ref(true);
    if (route.name == "reportIndex") {
      hideCompareBtnRef.value = false;
    }
    const ceping_src = ref(null);
    const is_zh = ref(false);

    // 历史数据处理
    const hasOldData = computed(() => {
      return props_oldData.value && Array.isArray(props_oldData.value) && props_oldData.value.length > 0;
    });

    const getOldScore = (oldItem) => {
      if (!oldItem) return '';
      return is_zh.value ? oldItem.total_score : oldItem.score;
    };

    const getOldVersion = (oldItem) => {
      if (!oldItem) return '';
      return oldItem.version || '';
    };

    const getOldModelName = (oldItem) => {
      if (!oldItem) return '';
      return oldItem.model_name || '';
    };

    const getOldEnergyType = (oldItem) => {
      if (!oldItem) return '';
      return getEnergyType(oldItem.energy_type);
    };

    const getOldPrice = (oldItem) => {
      if (!oldItem) return '';
      return oldItem.price || '';
    };

    const changePath = (new_path) => {
      if (new_path.indexOf("rank/0") > -1) {
        ceping_src.value = null;
        if (new_path.indexOf("rank/0-") == -1) {
          is_zh.value = true;
        }
      } else if (['4922', '4941', '4963', '4983', '5003', '5036', '5057', '5123', '5165', '5195'].indexOf(route.params.id) > -1) {
        ceping_src.value = {
          path: props.route_type + "/v2/contrast/analyse/func",
          query: {
            model_img: props.data.model_img,
            model_name: props.data.short_name || props.data.model_name,
            model_id: props.data.model_id,
            report_id: props.data.report_id,
          }
        };
      } else if (["4228", "4481", "4520", "4548"].indexOf(route.params.id) > -1) {
        ceping_src.value = {
          path: props.route_type + "/v2/contrast/analyse/base",
          query: {
            model_img: props.data.model_img,
            model_name: props.data.short_name || props.data.model_name,
            model_id: props.data.model_id,
            report_id: props.data.report_id,
          }
        };
      } else if (["4575",
        "4600",
        "4685",
        "4760",
        "4779",
        "4828",
        "4861",
        "4880"].indexOf(route.params.id) > -1) {
        ceping_src.value = {
          path: props.route_type + "/v2/contrast/analyse/trip",
          query: {
            model_img: props.data.model_img,
            model_name: props.data.short_name || props.data.model_name,
            model_id: props.data.model_id,
            report_id: props.data.report_id,
          }
        };
      } else if (['1-2', '0-2', '1', '2', '3'].indexOf(route.params.id) > -1) {
        ceping_src.value = {
          path: props.route_type + "/v2/contrast/evaluation",
          query: {
            model_img: props.data.model_img,
            model_name: props.data.short_name || props.data.model_name,
            model_id: props.data.model_id,
            model_ids: '[]',
            report_id: props.data.report_id,
            node_id: 4,
          }
        };
      }
    };
    changePath(route.path);
    watch(() => route.path, (new_path) => {
      changePath(new_path);
    });

    const toPage = (path, data) => {
      const query = {};
      query.model_id = data.model_id;
      query.report_id = data.report_id;
      router.push({
        path: props.route_type + path,
        query: {
          model_img: data.model_img,
          model_name: data.short_name || data.model_name,
          model_id: data.model_id,
          report_id: data.report_id
        },
      });
    };
    // const addCompareCar = (model_info, my_model_info) => {
    //   let model_id_str = [model_info, my_model_info]
    //   .map((item) => {
    //     return item.model_id;
    //   })
    //   .join(",");
    //   store.clearCompareCarDataV2();
    //   store.getCompareCarDataV2();
    //   store.setCompareCarDataV2({
    //     model_id: my_model_info.model_id,
    //     model_img: my_model_info.model_img,
    //     model_name: my_model_info.short_name,
    //     report_id: my_model_info.report_id,
    //   });
    //   router.push({
    //     path: props.route_type + "/contrast/multi_analyse/index",
    //     query: {
    //       model_id: model_id_str,
    //     },
    //   });
    // };
    const openCarAttrDrawer = (model_id) => {
      emit("openCarAttrDrawer", model_id);
    };

    // 历史版本功能方法
    const openOldCarAttrDrawer = (model_id) => {
      emit("openCarAttrDrawer", model_id);
    };

    const toOldPage = (path, data) => {
      const query = {};
      query.model_id = data.model_id;
      query.report_id = data.report_id;
      router.push({
        path: props.route_type + path,
        query: {
          model_img: data.model_img,
          model_name: data.short_name || data.model_name,
          model_id: data.model_id,
          report_id: data.report_id
        },
      });
    };

    const contrastListRef = computed(() => {
      return props.route_type == "/drive"
        ? store.state.compareCarDataV2_drive
        : store.state.compareCarDataV2;
    });
    const contrastListIds = ref([]);
    contrastListIds.value =
      (contrastListRef.value &&
        contrastListRef.value.map((item) => {
          return item.model_id * 1;
        })) ||
      [];
    watch(contrastListRef, (new_val) => {
      contrastListIds.value = new_val.map((item) => {
        return item.model_id * 1;
      });
    });
    watch(
      () => props.data,
      (new_val) => {
        props_data.value = new_val;
      }
    );
    watch(
      () => props.oldData,
      (new_val) => {
        props_oldData.value = new_val && typeof new_val === 'object' ? new_val : {};
      }
    );
    const checkChange = (item, type) => {
      //选中
      if (type) {
        let data = [];
        data =
          props.route_type == "/drive"
            ? store.getCompareCarDataV2_drive()
            : store.getCompareCarDataV2();
        if (data.length >= 3) {
          ElMessage.error("只能对比3款车型!");
          return;
        }
        let model_data = {
          model_id: item.model_id,
          report_id: item.report_id,
          model_name: item.short_name,
          model_img: item.model_img,
          review_model_id: item.review_model_id == 1 ? '5.0' : '4.0',
        };
        props.route_type == "/drive"
          ? store.setCompareCarDataV2_drive(model_data)
          : store.setCompareCarDataV2(model_data);
      } else {
        //取消选中
        props.route_type == "/drive"
          ? store.deleteCompareCarDataV2_drive(item.model_id)
          : store.deleteCompareCarDataV2(item.model_id);
      }
    };

    const ChangeCollect = (type, itemData = null) => {
      // 确定要操作的数据项
      const targetData = itemData || props_data.value;

      if (type == "add") {
        let promiseFn = props.route_type == "/drive" ? addCollectV2 : addCollectV2;
        promiseFn({
          model_id: targetData.model_id,
        })
          .then((res) => {
            if (res && res.code && res.code == 200) {
              ElMessage.success("加入收藏成功！");
              targetData.is_collect = 1;
              emit("changeCollect", "add");
            } else {
              ElMessage.error((res && res.message) || "加入收藏失败！");
            }
          })
          .catch(() => {
            ElMessage.error("加入收藏失败！");
          });
      } else if (type == "del") {
        let promiseFn = props.route_type == "/drive" ? delCollectV2 : delCollectV2;
        promiseFn({
          model_id: targetData.model_id,
        })
          .then((res) => {
            if (res && res.code && res.code == 200) {
              ElMessage.success("删除收藏成功！");
              targetData.is_collect = 0;
              emit("changeCollect", "del");
            } else {
              ElMessage.error((res && res.message) || "删除收藏失败！");
            }
          })
          .catch(() => {
            ElMessage.error("删除收藏失败！");
          });
      }
    };
    const noPermission = () => {
      ElMessage.error("暂无下载权限!");
    };

    // 处理下载报告按钮点击，触发和测评数据按钮相同的事件
    const handleDownloadReport = (item) => {
      if (item.download_permission) {
        // 如果有权限，触发下载链接
        const downloadUrl = apiUrl + 'v2/report/download?model_id=' + item.model_id;
        window.location.href = downloadUrl;
      } else {
        // 如果没有权限，调用无权限提示
        noPermission();
      }
    };

    const downloadSummary = () => {
      ElMessage.info("功能开发中...");
    };

    const downloadComparison = () => {
      ElMessage.info("功能开发中...");
    };

    // 历史数据展开/收起状态
    const showHistoryData = ref(false);
    const toggleHistoryData = () => {
      showHistoryData.value = !showHistoryData.value;
    };

    // 控制报告显示隐藏的变量
    const showExpertReport = ref(false);  // 单车专家测评报告
    const showUserReport = ref(false);    // 单车用户测评报告

    return {
      props_data,
      props_oldData,
      hideCompareBtnRef,
      getEnergyType,
      toPage,
      // addCompareCar,
      openCarAttrDrawer,
      openOldCarAttrDrawer,
      toOldPage,
      contrastListRef,
      contrastListIds,
      checkChange,
      ChangeCollect,
      ceping_src,
      is_zh,
      apiUrl,
      hasOldData,
      getOldScore,
      getOldVersion,
      getOldModelName,
      getOldEnergyType,
      getOldPrice,
      downloadSummary,
      downloadComparison,
      noPermission,
      handleDownloadReport,
      showHistoryData,
      toggleHistoryData,
      showExpertReport,
      showUserReport,
    };
  },
};
</script>
<style scoped lang="less">
.rank_item {
  width: 100%;
  min-height: 130px;
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e5eaee;
  flex-direction: column;
  align-items: stretch;

  .rank_main_content {
    width: 100%;
    display: flex;
    align-items: center;
    min-height: 130px;
    flex-shrink: 0;

    .rank_ranking {
      width: 38px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      font-size: 18px;
      color: #8f8f8f;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/rank_20221229.png) no-repeat center center;
      background-size: 35px 38px;

      &.ranking1 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/rank_1_20221229.svg) no-repeat center center;
        background-size: 38px 38px;
      }

      &.ranking2 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/rank_2_20221229.svg) no-repeat center center;
        background-size: 38px 38px;
      }

      &.ranking3 {
        background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/rank_3_20221229.svg) no-repeat center center;
        background-size: 38px 38px;
      }
    }

    .rank_short_desc {
      margin-left: 20px;
      width: 137px;

      .rank_short_name {
        font-size: 14px;
        font-weight: bold;
        color: #404e5b;
        line-height: 19px;
      }

      .rank_score {
        margin-top: 2px;
        height: 24px;
        font-size: 18px;
        font-weight: bold;
        color: #cb1c00;
        line-height: 24px;
      }
    }

    .rank_img {
      width: 160px;
      height: auto;
      min-height: 80px;
      position: relative;

      &.rank_new {
        position: relative;

        &::after {
          content: "";
          width: 36px;
          height: 18px;
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/new_20230223.png) no-repeat center center;
          background-size: 100%;
          position: absolute;
          right: 0;
          top: -5px;
        }
      }

      img {
        display: block;
        width: 100%;
        height: auto;
      }

      .no_promission {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .no_promission_icon {
          width: 31px;
          height: 31px;
          background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/suo_20221229.png) no-repeat center center;
          background-size: 100%;
        }

        .no_promission_text {
          margin-top: 5px;
          height: 16px;
          font-size: 12px;
          color: #000000;
          line-height: 16px;
          letter-spacing: 1px;
          text-align: center;
        }
      }
    }

    .rank_desc {
      margin-left: 30px;
      min-width: 300px;

      .rank_desc_line {
        display: flex;
        align-items: center;
        margin: 4px 0;

        .rank_desc_item {
          display: flex;
          align-items: center;
          min-width: 113px;

          .rank_attr {
            font-size: 14px;
            color: #404e5b;
          }

          .rank_val {
            font-size: 14px;
            font-weight: bold;
            color: #404e5b;
          }
        }
      }
    }

    .rank_btns {
      margin-left: auto;
      display: flex;

      .rank_btn {
        margin-left: 16px;
        width: 60px;
        position: relative;
        cursor: pointer;

        .rank_btn_icon {
          margin: 0 auto;
          width: 42px;
          height: 42px;
          border-radius: 50%;

          &:hover {
            background-color: #fafafa;
          }

          background-position: center center;
          background-repeat: no-repeat;

          &.icon_zs {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/zs_20221229.png);
            background-size: 22px;
          }

          &.icon_xzbg {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/xzbg.png);
            background-size: 22px;
          }

          &.icon_zs_gray {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/zsh_20221229.png);
            background-size: 22px;
          }

          &.icon_cp {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/pc_20221229.png);
            background-size: 22px;
          }

          &.icon_cp_gray {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/pch_20221229.png);
            background-size: 22px;
          }

          &.icon_db {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/db_2023_0109.svg);
            background-size: 22px;
          }

          &.icon_db_gray {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/dbh_20221229.png);
            background-size: 22px;
          }

          &.icon_db_act {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/db2_2023_0109.svg);
            background-size: 22px;
          }

          &.icon_sc {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/sc_20230109.svg);
            background-size: 22px;
          }

          &.icon_sc_gray {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/sch_20221229.png);
            background-size: 22px;
          }

          &.icon_xzbg_gray {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/xzbg_gray.png);
            background-size: 22px;
          }

          &.icon_sc_act {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/scc_20221229.png);
            background-size: 22px;
          }

          &.icon_gn {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gn_20221229.png);
            background-size: 22px;
          }

          &.icon_gn_gray {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gnh_20221229.png);
            background-size: 22px;
          }

          // &.icon_gn_act{
          //   background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gnl_20221229.png);
          //   background-size: 22px;
          // }
        }

        .rank_btn_text {
          margin: 0 auto;
          font-size: 12px;
          color: #404e5b;
          line-height: 16px;
          text-align: center;
        }

        .rank_function {
          cursor: pointer;
          display: none;
          position: absolute;
          top: 58px;
          left: 50%;
          transform: translateX(-50%);
          width: 133px;
          height: 120px;
          background: #252245;
          border-radius: 4px;
          opacity: 0.95;
          overflow: hidden;

          .rank_function_item {
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: #b7b7b7;

            &:hover {
              background: #0e0a31;
              font-weight: bold;
              color: #26e6ea;
            }
          }
        }

        .rank_download {
          cursor: pointer;
          display: none;
          position: absolute;
          top: 58px;
          left: 50%;
          transform: translateX(-50%);
          width: 160px;
          min-height: 40px;
          background: #252245;
          border-radius: 4px;
          opacity: 0.95;
          overflow: hidden;

          .rank_download_item {
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: #b7b7b7;
            text-decoration: none;
            display: block;

            &:hover {
              background: #0e0a31;
              font-weight: bold;
              color: #26e6ea;
            }
          }
        }

        &.rank_btn_gn:hover {
          .rank_function {
            z-index: 1;
            display: block;
          }

          .icon_gn {
            background-color: #fafafa;
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/gnl_20221229.png);
          }
        }

        &.rank_btn_xzbg:hover {
          .rank_download {
            z-index: 1;
            display: block;
          }

          .icon_xzbg {
            background-color: #fafafa;
          }
        }
      }
    }
  }

  // 历史描述样式 - 独立一行
  .rank_old_desc {
    margin-left: 30px;
    // padding-top: 12px;
    border-top: 1px dashed #e5e5e5;
    width: calc(100% - 30px);

    .rank_main_content {
      // margin-bottom: 12px;
      padding: 8px 0px;
      background: #f8f9fa;
      border-radius: 4px;
      min-height: auto;

      &:last-child {
        margin-bottom: 0;
      }

      .rank_short_desc {
        width: 500px;
      }

    }


  }

  .rank_history_btn {
    margin: 5px auto;
    padding: 5px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #f8f9fa;
    border: 1px solid #e5eaee;
    border-radius: 20px;
    width: fit-content;
    transition: all 0.3s ease;

    &:hover {
      background: #e9ecef;
      border-color: #cb1c00;
      box-shadow: 0 2px 8px rgba(203, 28, 0, 0.1);
    }

    .rank_history_icon {
      width: 16px;
      height: 16px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/history_630.png) no-repeat center center;
      background-size: 16px 16px;
      transition: transform 0.3s ease;

      &.expanded {
        background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/history_630.png);
        background-size: 16px 16px;
        transform: rotate(180deg);
      }
    }

    .rank_history_text {
      margin-left: 8px;
      font-size: 13px;
      color: #404e5b;
      line-height: 16px;
      font-weight: 500;
    }
  }
}
</style>